import { UserMarket } from 'types';
import { CapitolaClient } from './base';

export default class UserMarketClient extends CapitolaClient<UserMarket> {
  public get resourceName(): string {
    return 'user-market';
  }
}
